var _path, _polygon, _circle, _path2, _path3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8RwandaCircular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1e88e5",
    d: "M43.888,26c0.065-0.658,0.101-1.325,0.101-2c0-11.046-8.954-20-20-20c-11.046,0-20,8.954-20,20 c0,0.675,0.036,1.342,0.101,2H43.888z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffd600",
    points: "29.5,8 29.874,13.661 31.7,8.29 30.596,13.855 33.75,9.139 31.243,14.228 35.51,10.49 31.772,14.757 36.861,12.25 32.145,15.404 37.71,14.3 32.339,16.126 38,16.5 32.339,16.874 37.71,18.7 32.145,17.596 36.861,20.75 31.772,18.243 35.51,22.51 31.243,18.772 33.75,23.861 30.596,19.145 31.7,24.71 29.874,19.339 29.5,25 29.126,19.339 27.3,24.71 28.404,19.145 25.25,23.861 27.757,18.772 23.49,22.51 27.228,18.243 22.139,20.75 26.855,17.596 21.29,18.7 26.661,16.874 21,16.5 26.661,16.126 21.29,14.3 26.855,15.404 22.139,12.25 27.228,14.757 23.49,10.49 27.757,14.228 25.25,9.139 28.404,13.855 27.3,8.29 29.126,13.661"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.5,
    cy: 16.5,
    r: 2.615,
    fill: "#ffd600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1e88e5",
    d: "M29.5,19.215c-1.497,0-2.715-1.218-2.715-2.715s1.218-2.715,2.715-2.715s2.715,1.218,2.715,2.715 S30.997,19.215,29.5,19.215z M29.5,13.984c-1.387,0-2.516,1.129-2.516,2.516s1.129,2.516,2.516,2.516s2.516-1.129,2.516-2.516 S30.887,13.984,29.5,13.984z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd600",
    d: "M7.294,35h33.39c1.738-2.633,2.876-5.696,3.204-9H4.09C4.419,29.304,5.556,32.367,7.294,35z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#2e7d32",
    d: "M23.989,44c6.98,0,13.117-3.581,16.695-9H7.294C10.872,40.419,17.01,44,23.989,44z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8RwandaCircular);
export default __webpack_public_path__ + "static/media/icons8-rwanda-circular.966ce5a2a9700ef97ab01821705ff9a2.svg";
export { ForwardRef as ReactComponent };